module.exports = __webpack_public_path__ + "static/img/404.9c515fe3.png";